﻿$(document).ready(function () {
    toggleScroll();
});

module.exports = function ($scope) {
    //var tmp = document.getElementsByClassName("navbar-nav")[0];
    //if (tmp) {
    //    tmp.addEventListener("click", function () {
    //        menuClick();
    //    });
    //}
}

$(window).on("scroll", function () {
    toggleScroll();
});
function toggleScroll() {

    if (window.pageYOffset >= 150) {
        $("header").addClass("fixed-theme");
        $("header").addClass("inverse");
        $("header").removeClass("active-yellow");
    }
    else {
        $("header").removeClass("fixed-theme");
        $("header").removeClass("inverse");
        $("header").addClass("active-yellow");
    }
}
//function menuClick() {
//    window.dataLayer.push({
//        'event': 'content_click'

//    });
//}



//////////////////
// WEBPACK FOOTER
// ../scripts/yit/controllers/header.js
// module id = 14
// module chunks = 0